module.exports = __webpack_public_path__ + "img/Acess From Anywhere.19cf6ff7.png";